import type { MessageDescriptor } from 'react-intl';
import { PROFILE_MANUAL_SERVICES, type ProfileManualService } from 'fym-shared/src/music24/artistProfile';
import { sendAllMessages as s } from './sendAllMessages';

/** A profile that Music24 cannot reach: the artist downloads the file and sets it by hand (design c2). */
export const HAND_SERVICES = PROFILE_MANUAL_SERVICES;
export type HandService = ProfileManualService;

export interface HandServiceFacts {
  name: string;
  /** The letters of the small logo. */
  logo: string;
  /** What the service takes. */
  takes: MessageDescriptor;
  /** The profile edit page of the service (a new tab). */
  settingsUrl: string;
}

export const HAND_SERVICE_FACTS: Readonly<Record<HandService, HandServiceFacts>> = {
  instagram: {
    name: 'Instagram',
    logo: 'IG',
    takes: s.handInstagram,
    settingsUrl: 'https://www.instagram.com/accounts/edit/',
  },
  tiktok: { name: 'TikTok', logo: 'TT', takes: s.handTiktok, settingsUrl: 'https://www.tiktok.com/setting' },
  threads: { name: 'Threads', logo: '@', takes: s.handThreads, settingsUrl: 'https://www.threads.com/' },
  soundcloud: {
    name: 'SoundCloud',
    logo: 'SC',
    takes: s.handSoundcloud,
    settingsUrl: 'https://soundcloud.com/settings',
  },
  appleMusic: {
    name: 'Apple Music for Artists',
    logo: 'A',
    takes: s.handApple,
    settingsUrl: 'https://artists.apple.com/',
  },
  amazonMusic: {
    name: 'Amazon Music for Artists',
    logo: 'a',
    takes: s.handAmazon,
    settingsUrl: 'https://artists.amazonmusic.com/',
  },
  tidal: { name: 'TIDAL', logo: 'T', takes: s.handTidal, settingsUrl: 'https://artists.tidal.com/' },
  bandcamp: { name: 'Bandcamp', logo: 'B', takes: s.handBandcamp, settingsUrl: 'https://bandcamp.com/login' },
  x: { name: 'X', logo: 'X', takes: s.handX, settingsUrl: 'https://x.com/settings/profile' },
};
